module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_lomma-ade886675d85e4678eeb7d9d62e5aacc.png";